import { getRootDomain } from "../helpers";

export const API_URL = {
     local: {
          stage: "http://localhost:4000",
          'dev/schools': "http://localhost:4000",
          'dev/event': "http://localhost:4000",
          'dev/class': "http://localhost:4000",
          evnts: "http://localhost:4001",
          users: "http://localhost:4002",
          services: "http://localhost:4003",
          bookings: "http://localhost:4003",
          foods: "http://localhost:4005",
     },
     dev: "https://bmcapi-dev.bookzy.app",
     prod: "https://bmcapi-prod.bookzy.app",
     cron: "https://api-gen.bookzy.app",
};

export const WEBSHOP_URL = {
     local: {
          event: "https://event-dev.bookzyme.com",
          services: "https://event-dev.bookzyme.com",
          class: "https://event-dev.bookzyme.com",
          foods: "https://event-dev.bookzyme.com",
     },
     dev: {
          event: "https://event-dev.bookzyme.com",
          services: "https://event-dev.bookzyme.com",
          class: "https://event-dev.bookzyme.com",
          foods: "https://event-dev.bookzyme.com",
     },
     prod: {
          event: "https://events.bookzyme.com",
          services: "https://webshop.bookzyme.com",
          class: "https://webshop.bookzyme.com",
          foods: "https://webshop.bookzyme.com",
     },
};

export const CURRENT_ENV = process.env?.REACT_APP_APP_ENV || "dev";
// export const CURRENT_ENV = "local";

export const getUrlForModule = (modulePath, forwardSlash = true) => {
     if (CURRENT_ENV == 'local') {
          return `${API_URL[CURRENT_ENV][modulePath]}/dev${forwardSlash ? `/` : ``}`
     }
     return `${API_URL[CURRENT_ENV]}/${modulePath}${forwardSlash ? `/` : ``}`
}

export const getUrlForStage = () => {
     return getUrlForModule(CURRENT_ENV)
}

export const getUrlForEvent = () => {
     return getUrlForModule(`evnts`)
}

export const getUrlForUsers = () => {
     return getUrlForModule(`users`)
}

export const getUrlForClasses = (path = 'schools') => {
     return getUrlForModule(`${CURRENT_ENV || 'dev'}${path !== "" ? "/" + path : ""}`)
}

export const getUrlForServices = () => {
     return getUrlForModule(`services`)
}

export const getUrlForBookings = () => {
     return getUrlForModule(`bookings`)
}

export const getUrlForFoods = () => {
     return getUrlForModule(`foods`)
}

export const getUrlForCronServer = () => {
     return `${API_URL['cron']}/${CURRENT_ENV}/`
}

export const getWebshopUrlForModule = (modulePath) => {
     return `${WEBSHOP_URL[CURRENT_ENV][modulePath]}/`
}

export const getWebshopUrlForEvent = () => {
     return getWebshopUrlForModule(`event`)
}

export const getDomainUrl = () => {
     const host = window.location.hostname; // e.g. fitclub.example.com
     const parts = host.split(".");

     // first part is subdomain
     const subdomain = parts[0].toLowerCase();
     console.log("subdomain", subdomain);

     if ((subdomain && subdomain === "localhost") || CURRENT_ENV == 'local') {
          return `http://localhost:3000/`
     }
     if (CURRENT_ENV == 'dev') {
          return `https://sandbox.bookzyme.com/`
     }
     return `https://business.bookzyme.com/`
}

export const getTenantDomainUrl = (userData) => {
     let subdomain = ""
     if (userData.userType === "teacher") {
          subdomain = userData?.myBookingLink || ""
     } else if (userData.userType === "student") {
          const host = window.location.hostname; // e.g. fitclub.example.com
          const parts = host.split(".");
          subdomain = parts[0].toLowerCase();
     }
     console.log("getTenantDomainUrl subdomain", subdomain);

     if (CURRENT_ENV == 'local') {
          return `http://localhost:3000/`
     }
     // if (CURRENT_ENV == 'dev') {
     //      return `https://${subdomain}.bookzyme.com/`
     // }
     return `${window.location.protocol}//${subdomain}.${getRootDomain()}/`
}

export function isRootDomain() {
     const host = window.location.hostname; // e.g., "example.com" or "sub.example.com"
     // Split into parts
     const parts = host.split(".");
     // If domain has only 2 parts (like example.com) → no subdomain
     // If more than 2 parts (like sub.example.com) → has subdomain
     return host !== "localhost" && parts.length === 2;
}

export function redirectWithwwwRootDomain() {
     const newUrl = window.location.protocol + "//www." + (window.location.hostname) + window.location.pathname + window.location.search + window.location.hash;
     window.location.replace(newUrl);
}